import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonLabel, IonFab, IonFabButton, IonIcon, useIonModal, IonButtons, IonButton } from '@ionic/react';
import { useState, useEffect } from 'react';
import { addOutline, chevronBack } from 'ionicons/icons';
import { useHistory } from 'react-router';
import ServiceEditor from './ServiceEditor';
import { addServiceListener } from '../firebase/services';

const Service: React.FC = () => {
  const history = useHistory();
  const [services, setServices] = useState([]);
  const [service, setService] = useState({});

  useEffect(() => {
    addServiceListener((list: any) => {
      setServices(list);
    });
  }, []);

  const [presentEditor, dismissEditor] = useIonModal(ServiceEditor, {
    service: service,
    onDismiss: () => dismissEditor()
  });

  function openEditor(e: any = null) {
    if (e !== null) {
      setService(e);
    } else {
      setService({})
    }

    presentEditor();
  }

  return (
    <IonPage >
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton color="medium" onClick={history.goBack}>
              <IonIcon icon={chevronBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>Usługi</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>


        {services.map((s: any) => (
          <IonItem onClick={(e) => { openEditor(s) }} key={s.id} >
            <IonLabel>{s.name}</IonLabel>
          </IonItem>
        ))}

        <IonFab vertical="bottom" horizontal="end" slot="fixed">
          <IonFabButton onClick={() => { openEditor() }}>
            <IonIcon icon={addOutline}></IonIcon>
          </IonFabButton>
        </IonFab>
      </IonContent>
    </IonPage>
  );
};

export default Service;
